<template>
  <div class="w-100">
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateFrom"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateTo"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3 d-flex align-items-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('reports.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('reports.btn.apply') }}</b-button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <b-card
            no-body
            border-variant="secondary"
            :header="$t('title.report.affiliate_quick_summary')"
            header-bg-variant="secondary"
            header-text-variant="white"
            align="left"
        >
          <table v-if="affiliateQuickSummary" class="table table-striped mb-0">
            <tbody>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.registrations') }}</td>
              <td>{{ affiliateQuickSummary.registrations }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.registrations_ratio') }}</td>
              <td>{{ affiliateQuickSummary.registrationsRatio }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.new_depositing_accounts_count') }}</td>
              <td>{{ affiliateQuickSummary.newDepositingAccountsCount }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.active_accounts') }}</td>
              <td>{{ affiliateQuickSummary.activeAccounts }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.first_deposit_count') }}</td>
              <td>{{ affiliateQuickSummary.firstDepositCount }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.new_accounts_purchases') }}</td>
              <td>{{ affiliateQuickSummary.newAccountsPurchases }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.depositing_accounts') }}</td>
              <td>{{ affiliateQuickSummary.depositingAccounts }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.deposits') }}</td>
              <td>{{ affiliateQuickSummary.deposits }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.affiliate_quick_summary.gross_revenue') }}</td>
              <td>{{ affiliateQuickSummary.grossRevenue }}</td>
            </tr>

            </tbody>
          </table>
          <div class="spinner-wrapper" v-else>
            <b-spinner></b-spinner>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";
import CalendarPlaceholder from "./CalendarPlaceholder";

export default {
  components: {
    DateRangePicker,
    CalendarPlaceholder
  },
  data() {
    return {
      dateFrom: {
        startDate: null
      },
      dateTo: {
        startDate: null
      }
    }
  },
  computed: {
    ...mapState({
      affiliateQuickSummary: (state) => state.reports.affiliateQuickSummary,
    }),
  },
  mounted() {
    this.getReport();
  },
  beforeDestroy() {
    this.$store.commit('reports/setAffiliateQuickSummary', null);
  },
  methods: {
    clearFilters() {
      this.dateFrom = { startDate: null };
      this.dateTo = { startDate: null };

      this.getReport();
    },
    getReport() {
      const date = {
        dateFrom: this.dateFrom.startDate ? moment(this.dateFrom.startDate).format('YYYY-MM-DD') : null,
        dateTo: this.dateTo.startDate ? moment(this.dateTo.startDate).format('YYYY-MM-DD') : null
      }

      this.$store.dispatch('reports/getAffiliateQuickSummaryReport', date);
    }
  }
}
</script>
